import { Dayjs } from "dayjs"
import { PrizeDrawEntryWinnerStatus } from "@/api/backofficeRest/generated/model"
import { IDrawWinner } from "./drawWinner.types"

export class DrawWinner implements IDrawWinner {
  constructor(
    public id: string,
    public billingAccountId: string,
    public accountNumber: string,
    public prizeDrawRewardId: string | null,
    public surname: string,
    public county: string,
    public nameVisibilityOptOut: boolean,
    public status: PrizeDrawEntryWinnerStatus,
    public rewardProcessError: string | null = null,
    public lastWonDate: Dayjs | null = null,
  ) {}
}
